import type { TableColumn } from "./description";
// FIXME: Almost none of this has anything to do with Google Sheets

export const rowIndexColumnName = "$rowIndex";

export function makeRowIndexTableColumn(typeKind: "number" | "string"): TableColumn {
    return {
        name: rowIndexColumnName,
        type: { kind: typeKind },
        hidden: true,
        isProtected: false,
        isUserSpecific: false,
    };
}

// FIXME: These don't belong here, as they have nothing to do with Google Sheets
export const isFavoritedColumnName = "$isFavorited";

// FIXME: This belongs in functions
export const isFavoritedTableColumn: TableColumn = {
    name: isFavoritedColumnName,
    displayName: "Is Favorited?",
    type: { kind: "boolean" },
    isUserSpecific: true,
    isProtected: false,
};

export const rowAddedByJobColumnName = "$rowAddedByJob";
// Note that we don't have a TableColumn for this. It's not actually important
// to the schema; it's only used as part of the data store's update reconciliation.

export const defaultRowIDColumnName = "🔒 Row ID";

export type RefreshResult =
    | "refreshed"
    | "no-changes"
    | "reload-disabled"
    | "quota-reached"
    | "automatic-refresh-only"
    | "requested"
    | "incompatible"
    | "error"
    | "timeout";
